module.exports = __webpack_public_path__ + "img/invite.47d8adeb.png";